/* import __COLOCATED_TEMPLATE__ from './market-i-icon.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();